// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
import { WeightMeterActions, WeightMeterActionTypes } from '../_actions/weight-meter.actions';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { WeightMeter} from '../_models/weight-meter.model';

// tslint:disable-next-line:no-empty-interface
export interface WeightMeterState extends EntityState<WeightMeter> {
    listLoading: boolean;
    actionsloading: boolean;
    totalCount: number;
    lastCreatedWeightMeterId: number;
    lastUpdatedWeightMeterId: number;
    lastDeletedWeightMeterId: number;
    lastQuery: QueryParamsModel;
    showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<WeightMeter> = createEntityAdapter<WeightMeter>();

export const initialWeightMeterState: WeightMeterState = adapter.getInitialState({
    listLoading: false,
    actionsloading: false,
    totalCount: 0,
    lastQuery:  new QueryParamsModel({}),
    lastCreatedWeightMeterId: undefined,
    lastUpdatedWeightMeterId: undefined,
    lastDeletedWeightMeterId: undefined,
    showInitWaitingMessage: true
});

export function weightMetersReducer(state = initialWeightMeterState, action: WeightMeterActions): WeightMeterState {
    switch  (action.type) {
        case WeightMeterActionTypes.WEIGHT_METER_ADDED: return adapter.addOne(action.payload.weightMeter, {
            ...state, lastCreatedWeightMeterId: action.payload.weightMeter.id
        });
        case WeightMeterActionTypes.WEIGHT_METER_EDITED: return adapter.updateOne(action.payload.partialWeightMeter, 
            {...state, lastUpdatedWeightMeterId: action.payload.weightMeter.id});
        case WeightMeterActionTypes.WEIGHT_METER_PAGE_LOADED: return adapter.addMany(action.payload.weightMeters, {
            ...initialWeightMeterState,
            totalCount: action.payload.totalCount,
            lastQuery: action.payload.page,
            listLoading: false,
            showInitWaitingMessage: false
        });
        case WeightMeterActionTypes.WEIGHT_METER_ALL_LOADED: return adapter.addMany(action.payload.weightMeters, {
            ...initialWeightMeterState,
            listLoading: false,
            showInitWaitingMessage: false
        });
        case WeightMeterActionTypes.WEIGHT_METER_DELETED: return adapter.removeOne(action.payload.id, 
            {...state, lastDeletedWeightMeterId: action.payload.id});
        // case UserActionTypes.UsersPageCancelled: return {
        //     ...state, listLoading: false, lastQuery: new QueryParamsModel({})
        // };
        default: return state;
    }
}

export const getWeightMeterState = createFeatureSelector<WeightMeterState>('weightMeters');

export const {
    selectAll,
    selectEntities,
    selectIds,
    selectTotal
} = adapter.getSelectors();